import { routes } from '../constants';
import Talk from '../pages/Talk';
import RichMenuAddFriend from '../pages/RichMenuAddFriend';
import Survey from '../pages/Survey';

type RouterConfig = {
  path: string;
  component: () => JSX.Element;
  isProtected?: boolean;
  children?: Array<{
    path: string;
    component: () => JSX.Element;
    index?: boolean;
  }>;
};

const routers: RouterConfig[] = [
  {
    path: routes.TALK,
    component: Talk,
  },
  {
    path: routes.TALKMAIL,
    component: Talk,
  },
  {
    path: routes.SURVEY,
    component: Survey,
    isProtected: false,
  },
  {
    path: routes.RICHMENU_ADD_FRIEND,
    component: RichMenuAddFriend,
    isProtected: false,
  },
];

export default routers;
